// Edit entity item action
export default class {
  constructor({ root, entity_type }, { entity }) {
    this.root = root;
    this.entity_type = entity_type;
    this.id = entity.id;
  }
  async execute() {
    this.root.$router.push({
      name: "entity_edit",
      params: { type: this.entity_type, id: this.id }
    });
  }
}
